module.exports = __webpack_public_path__ + "img/trx.6e61dfd0.svg";